(() => {
  if (customElements.get('njt-suspension')) return;
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const keys = {brand:'filter.p.m.organizer.product_brand',height:'njs_height',position:'njs_position',stock:'filter.v.availability',min:'filter.v.price.gte',max:'filter.v.price.lte'};
  const previewKeys = ['preview_theme_id','_fd','pb'];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  class SuspensionBrowser extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.initBackgroundQueue();
      this.model = window.NjtSuspensionModel;
      if (!this.model) return;
      this.labels = JSON.parse(this.querySelector('[data-njs-labels]').textContent);
      this.url = new URL(location.href);
      this.products = new Map(); this.rawProducts=new Map(); this.pages = new Set(); this.total = 0; this.complete = false;
      this.visible=Math.max(24,Number(window.NJTListReturn?.state()?.visible)||Number(history.state?.njsVisible)||24);
      this.returnSnapshot=window.NJTListReturn?.snapshot('.njs-grid');
      if(this.returnSnapshot){this.querySelector('.njs-grid').innerHTML=this.returnSnapshot.html;this.querySelector('.njs-count').textContent=this.returnSnapshot.count;this.dataset.listReady='true';}
      const moreButton=this.querySelector('.njs-more-options');
      const showMore=()=>{if(this.returnSnapshot&&!this.complete)return;this.visible+=24;this.render();};
      moreButton?.addEventListener('click',showMore);
      if(moreButton && 'IntersectionObserver' in window){this.moreObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))this.queueBackground(() => { showMore(); if(this.complete)this.render(true,true,true); });},{rootMargin:'400px 0px'});this.moreObserver.observe(moreButton);}
      this.form = this.querySelector('.njs-form'); this.dialog = this.querySelector('.njs-dialog');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-CA', {style:'currency',currency:this.dataset.currency || 'CAD'});
      this.mobile = matchMedia('(max-width: 749px)');
      this.onResize = () => this.placeForm(); this.mobile.addEventListener('change',this.onResize);
      this.onPop = () => {
        if (this.url.href === location.href) return;
        this.url = new URL(location.href);
        this.returnSnapshot = null;
        this.visible = Math.max(24, Number(history.state?.njtListReturn?.visible) || Number(history.state?.njsVisible) || 24);
        this.render(true);
      };
      this.outside = event => { if (!this.querySelector('.njs-more').contains(event.target)) this.querySelector('.njs-more').open = false; };
      window.addEventListener('popstate',this.onPop); document.addEventListener('click',this.outside);
      this.addEventListener('click',event => this.handleClick(event));
      this.addEventListener('keydown',event => { if (event.key === 'Escape') this.querySelector('.njs-more').open = false; });
      this.addEventListener('submit',event => {
        if (event.target !== this.form) return;
        event.preventDefault(); this.applyForm(); this.dialog.close();
      });
      this.form.addEventListener('change',event => { if(event.target.name==='njs_category'){this.applyForm();this.renderFilters();this.form.querySelector('input[name=njs_category]:checked')?.focus({preventScroll:true});}else if(!this.dialog.open)this.applyForm(); });
      this.dialog.addEventListener('close',() => { document.body.classList.remove('njs-modal-open'); this.placeForm(); this.renderFilters(); });
      this.dialog.addEventListener('click',event => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close(); });
      this.querySelectorAll('[data-njs-category]').forEach(link => link.dataset.base = link.getAttribute('href'));
      try { JSON.parse(this.querySelector('[data-njs-seed]').content.textContent).forEach((p,i) => this.products.set(p.id,this.model.prepare(p,i))); } catch (_) { /* Fetch can recover an unavailable seed. */ }
      const more = this.querySelector('.njs-more');
      more.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (min-width: 750px)').matches) more.open = true; });
      more.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !more.contains(document.activeElement)) more.open = false; });
      more.addEventListener('focusout', event => { if (!more.contains(event.relatedTarget)) more.open = false; });
      this.render(true); this.load();
    }
    disconnectedCallback() {
      this.clearBackgroundQueue();
      this.moreObserver?.disconnect();
      this.controller?.abort(); window.removeEventListener('popstate',this.onPop);
      document.removeEventListener('click',this.outside); this.mobile?.removeEventListener('change',this.onResize);
      document.body.classList.remove('njs-modal-open');
    }
    queueBackground(callback) {
      this.backgroundCallback = callback;
      if (this.backgroundTimer) return;
      const flush = () => {
        this.backgroundTimer = null;
        if (!this.isConnected) { this.backgroundCallback = null; return; }
        if (matchMedia('(max-width: 989px)').matches && (this.backgroundTouch || Date.now() - (this.backgroundScroll || 0) < 220)) {
          this.backgroundTimer = setTimeout(flush, 120);
          return;
        }
        const run = this.backgroundCallback;
        this.backgroundCallback = null;
        run?.();
      };
      this.backgroundTimer = setTimeout(flush, 160);
    }
    initBackgroundQueue() {
      this.onBackgroundScroll = () => { this.backgroundScroll = Date.now(); };
      this.onBackgroundTouch = event => { this.backgroundTouch = event.touches.length > 0; this.backgroundScroll = Date.now(); };
      window.addEventListener('scroll', this.onBackgroundScroll, {passive:true});
      window.addEventListener('touchstart', this.onBackgroundTouch, {passive:true});
      window.addEventListener('touchend', this.onBackgroundTouch, {passive:true});
      window.addEventListener('touchcancel', this.onBackgroundTouch, {passive:true});
    }
    clearBackgroundQueue() {
      clearTimeout(this.backgroundTimer);
      this.backgroundTimer = null;
      this.backgroundCallback = null;
      window.removeEventListener('scroll', this.onBackgroundScroll);
      window.removeEventListener('touchstart', this.onBackgroundTouch);
      window.removeEventListener('touchend', this.onBackgroundTouch);
      window.removeEventListener('touchcancel', this.onBackgroundTouch);
    }
    t(key) { return String(this.labels[key] || key).replace(/&(?:amp;)+/gi,'&'); }
    heightLabel(value) { return this.t(this.model.heightGroups.find(group=>group.value===value)?.label || value); }
    state() {
      const q=this.url.searchParams;
      if(q.getAll(keys.height).includes('unspecified')) {q.delete(keys.height,'unspecified');history.replaceState(history.state,'',this.url);}
      if(q.getAll(keys.height).includes('Stock height')) {
        const heights=[...new Set(q.getAll(keys.height).map(value=>value==='Stock height'?'under-2':value))];
        q.delete(keys.height);heights.forEach(value=>q.append(keys.height,value));history.replaceState(history.state,'',this.url);
      }
      return {category:this.model.category(this.url),vehicle:q.get(vehicleKey)||'',brands:q.getAll(keys.brand),heights:q.getAll(keys.height),positions:q.getAll(keys.position),stock:q.get(keys.stock)==='1',min:q.get(keys.min)||'',max:q.get(keys.max)||'',sort:q.get('sort_by')||'best-selling',page:Math.max(1,Number(q.get('page'))||1)};
    }
    placeForm() {
      if (!this.mobile.matches && this.dialog.open) this.dialog.close();
      const target = this.mobile.matches || this.dialog.open ? this.querySelector('.njs-dialog-body') : this.querySelector('.njs-sidebar');
      if (this.form.parentElement !== target) target.append(this.form);
    }
    navigate(url) {
      if (url.origin !== location.origin) return;
      history.replaceState({...history.state,njsVisible:this.visible},'');
      this.visible=24;this.returnSnapshot=null;this.url=url; history.pushState({},'',url); this.render(true);
      const top=this.querySelector('.njs-sticky').getBoundingClientRect().top;
      if (top < 0) this.scrollIntoView({block:'start',behavior:'instant'});
    }
    setVehicle(vehicle) {
      const url = new URL(location.href);
      if (vehicle) url.searchParams.set(vehicleKey, vehicle);
      else url.searchParams.delete(vehicleKey);
      url.searchParams.delete('page');
      this.visible = 24;
      this.returnSnapshot = null;
      this.url = url;
      if (url.href !== location.href) history.pushState({}, '', url);
      this.render(true);
    }
    applyForm() {
      const url=new URL(this.url);
      const category=this.form.elements.namedItem('njs_category')?.value;
      const changed=category && category!==url.pathname.split('/').filter(Boolean).pop();
      if(changed){url.pathname=new URL(this.dataset.source,location.origin).pathname.replace(/suspension\/?$/,category);}
      Object.values(keys).forEach(key=>url.searchParams.delete(key));
      url.searchParams.delete('page');
      for(const [key,value] of new FormData(this.form)) if(value!=='' && key!=='njs_category' && !(changed && [keys.brand,keys.height,keys.position].includes(key))) {
        if(key==='sort_by') url.searchParams.set(key,value); else url.searchParams.append(key,value);
      }
      this.navigate(url);
    }
    categoryURL(link) {
      const url=new URL(link.dataset.base,location.origin);
      for(const [key,value] of this.url.searchParams) {
        if([vehicleKey,keys.stock,keys.min,keys.max,'sort_by',...previewKeys].includes(key)) url.searchParams.append(key,value);
      }
      return url;
    }
    handleClick(event) {
      const button=event.target.closest('button');
      if(button?.matches('.njs-open')) {
        this.querySelector('.njs-dialog-body').append(this.form); this.dialog.showModal(); document.body.classList.add('njs-modal-open');
      }
      if(button?.matches('[data-njs-close]')) this.dialog.close();
      if(button?.matches('.njs-retry')) this.load();
      if(button?.matches('[data-njs-reset]')) {
        const url=new URL(this.url); Object.values(keys).forEach(key=>url.searchParams.delete(key)); url.searchParams.delete('page');
        this.dialog.close(); this.navigate(url);
      }
      if(button?.matches('[data-njs-vehicle]')) {
        const wrapper=document.querySelector('.section-vehicle-filter--wrapper');
        if(wrapper) { wrapper.classList.remove('closed'); wrapper.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); document.querySelector('#vehicle-makes')?.focus({preventScroll:true}); }
      }
      const link=event.target.closest('a');
      if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      if(link.matches('[data-njs-category]')) {
        event.preventDefault(); this.querySelector('.njs-more').open=false; this.navigate(this.categoryURL(link));
      } else if(link.matches('[data-njs-page],.njs-chips a')) {event.preventDefault(); this.navigate(new URL(link.href));}
    }
    async fetchPage(page,signal) {
      if(signal.aborted) throw new DOMException('Aborted','AbortError');
      const url=new URL(this.dataset.source,location.origin);
      url.searchParams.set('view','njt-suspension-data'); url.searchParams.set('page',page); url.searchParams.set('sort_by','best-selling');
      for(const key of previewKeys) if(this.url.searchParams.has(key)) url.searchParams.set(key,this.url.searchParams.get(key));
      // Deliberately omit native filter parameters: Shopify drops them above 5,000 products.
      const requestController=new AbortController();
      const abort=()=>requestController.abort(); signal.addEventListener('abort',abort,{once:true});
      const timer=setTimeout(abort,25000);
      try {
        const response=await fetch(url,{signal:requestController.signal});
        if(!response.ok) throw new Error('HTTP '+response.status);
        const data=await response.json();
        if(!Array.isArray(data.products) || Number(data.page)!==page || !Number.isFinite(Number(data.pages))) throw new Error('Invalid catalog response');
        return data;
      } finally {clearTimeout(timer); signal.removeEventListener('abort',abort);}
    }
    async catalogCache(value) {
      const key=JSON.stringify([this.dataset.source,this.dataset.currency,this.dataset.locale,this.url.searchParams.get('preview_theme_id')||'', '20261017f']);
      window.NjtSuspensionCache ||= new Map();
      if(value)window.NjtSuspensionCache.set(key,value);
      else if(window.NjtSuspensionCache.has(key))return window.NjtSuspensionCache.get(key);
      if(!window.indexedDB)return null;
      return new Promise(resolve=>{
        let database,finished=false;
        const finish=result=>{if(finished)return;finished=true;clearTimeout(timer);database?.close();resolve(result);};
        const timer=setTimeout(()=>finish(null),1200);
        const open=indexedDB.open('njt-suspension-catalog-v1',1);
        open.onupgradeneeded=()=>open.result.createObjectStore('indexes');
        open.onerror=()=>finish(null);open.onblocked=()=>finish(null);
        open.onsuccess=()=>{
          database=open.result;if(finished){database.close();return;}
          const transaction=database.transaction('indexes',value?'readwrite':'readonly');
          const request=value?transaction.objectStore('indexes').put(value,key):transaction.objectStore('indexes').get(key);
          let result=null;request.onsuccess=()=>{result=request.result;};
          transaction.oncomplete=()=>finish(value||result||null);transaction.onerror=()=>finish(null);transaction.onabort=()=>finish(null);
        };
      }).catch(()=>null);
    }
    async load() {
      if(this.loading) return;
      this.loading=true; this.error=false;
      const controller=new AbortController(); this.controller=controller;
      this.querySelector('.njs-retry').hidden=true; this.renderStatus();
      try {
        const cached=await this.catalogCache();
        if(cached && Date.now()-cached.at<180000 && Array.isArray(cached.products) && cached.products.length<=25000 && new Set(cached.products.map(p=>p.id)).size===cached.products.length){
          this.products=new Map(cached.products.map((p,i)=>[p.id,this.model.prepare(p,i)]));this.total=cached.products.length;this.complete=true;return;
        }
        if(!this.pages.has(1)) this.accept(await this.fetchPage(1,controller.signal));
        const pending=Array.from({length:this.pageCount},(_,i)=>i+1).filter(p=>!this.pages.has(p));
        let cursor=0;
        await Promise.all(Array.from({length:Math.min(3,pending.length)},async()=>{
          while(cursor<pending.length) {
            const page=pending[cursor++]; let data;
            for(let attempt=0;attempt<2;attempt++) {
              try {data=await this.fetchPage(page,controller.signal);break;} catch(error) {if(controller.signal.aborted || attempt===1) throw error;}
            }
            if(controller.signal.aborted) return;
            this.accept(data);
          }
        }));
        if(this.total>25000 || this.loadedIDs.size!==this.total) {
          this.pages.clear(); this.loadedIDs.clear();
          throw new Error('Incomplete catalog');
        }
        // Remove any stale seed product that is no longer part of the parent collection.
        for(const id of this.products.keys()) if(!this.loadedIDs.has(id)) this.products.delete(id);
        this.complete=true;
        this.catalogCache({at:Date.now(),products:[...this.products.values()].sort((a,b)=>a.rank-b.rank).map(p=>this.rawProducts.get(p.id))});
      } catch(error) {
        if(!this.isConnected) return;
        controller.abort(); this.error=true; this.querySelector('.njs-retry').hidden=false;
      } finally {this.loading=false; if(this.isConnected) this.render(true,true);}
    }
    accept(data) {
      this.loadedIDs ||= new Set(); this.total=Number(data.total); this.pageCount=Math.max(1,Number(data.pages)); this.pages.add(Number(data.page));
      data.products.forEach((p,i)=>{this.rawProducts.set(p.id,p);this.loadedIDs.add(p.id);this.products.set(p.id,this.model.prepare(p,(Number(data.page)-1)*250+i));});
      // Results appear as data arrives; the list never waits for a filter selection.
      this.render(!this.dialog.open,true);
    }
    renderStatus() {
      const status=this.querySelector('.njs-status'),height=status.getBoundingClientRect().height;
      if(height>0)status.style.minHeight=height+'px';
      status.textContent=this.error?this.t('partial_error'):this.complete?'':this.t('loading_more');
      this.querySelector('.njs-results').setAttribute('aria-busy',this.loading?'true':'false');
    }
    scrollAnchor() {
      if(this.dialog.open)return null;
      const grid=this.querySelector('.njs-grid');
      if(!grid || grid.getBoundingClientRect().top>0)return null;
      const edge=Math.max(0,this.querySelector('.njs-sticky').getBoundingClientRect().bottom);
      const card=[...grid.children].find(node=>node.dataset.productId && node.getBoundingClientRect().bottom>edge);
      return card ? {id:card.dataset.productId,top:card.getBoundingClientRect().top} : null;
    }
    render(rebuildFilters=false,preserveScroll=false,backgroundReady=false) {
      if (preserveScroll && !backgroundReady) {
        this.queueBackground(() => this.render(rebuildFilters, true, true));
        return;
      }
      const anchor=preserveScroll?this.scrollAnchor():null;
      const state=this.state(); this.placeForm();
      const more=this.querySelector('.njs-more'); more.classList.toggle('njs-more-active',!['all','lifts','leveling','shocks'].includes(state.category));
      this.querySelectorAll('[data-njs-category]').forEach(link=>{
        const url=this.categoryURL(link);link.href=url;
        if(this.model.category(url)===state.category) link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
      });
      document.dispatchEvent(new CustomEvent('njt:vehicle-state'));
      const active=this.querySelector('[data-njs-category][aria-current]');
      const heading=active?.querySelector('.njs-label-desktop')?.textContent || active?.textContent || this.t('title');
      this.querySelector('.njs-title').textContent=heading;
      this.dataset.category=state.category;
      const crumb=[...document.querySelectorAll('#breadcrumb .breadcrumb-item a')].pop();
      if(crumb && crumb.pathname.includes('/collections/')) {crumb.textContent=heading;crumb.href=this.url;}
      const result=[...this.products.values()].filter(p=>this.model.matches(p,state));
      const sorters={'price-ascending':(a,b)=>a.price-b.price,'price-descending':(a,b)=>b.price-a.price,'title-ascending':(a,b)=>a.title.localeCompare(b.title),'title-descending':(a,b)=>b.title.localeCompare(a.title),'created-descending':(a,b)=>Number(b.created)-Number(a.created),'created-ascending':(a,b)=>Number(a.created)-Number(b.created)};
      result.sort(sorters[state.sort]||((a,b)=>a.rank-b.rank));
      if(!this.returnSnapshot || this.complete) {
        this.returnSnapshot=null;
        this.visible=Math.max(this.visible,state.page*24);
        this.querySelector('.njs-count').textContent=`${result.length.toLocaleString()} ${this.t(this.complete?'products':'products_loaded')}`;
        if(anchor){const index=result.findIndex(p=>String(p.id)===anchor.id);if(index>=0)this.visible=Math.max(this.visible,index+1);}
        const shown=result.slice(0,this.visible), grid=this.querySelector('.njs-grid');
        const html=shown.map((p,i)=>this.card(p,state,i));
        const existing=new Map([...grid.children].map(node=>[node.dataset.productId,node]));
        const keep=new Set();
        html.forEach((markup,i)=>{
          const id=String(shown[i].id);let node=existing.get(id);
          if(!node || node.njsMarkup!==markup){const template=document.createElement('template');template.innerHTML=markup;const replacement=template.content.firstElementChild;replacement.njsMarkup=markup;if(node)node.replaceWith(replacement);node=replacement;}
          keep.add(node);
          if(grid.children[i]!==node)grid.insertBefore(node,grid.children[i]||null);
        });
        [...grid.children].forEach(node=>{if(!keep.has(node))node.remove();});
        this.renderedCards=html;
        this.querySelector('.njs-empty').hidden=!this.complete || result.length>0;
        this.querySelector('.njs-pagination').hidden=true;
        const moreButton=this.querySelector('.njs-more-options');
        if(moreButton)moreButton.hidden=this.visible>=result.length;
        this.dataset.listReady=this.complete?'true':'false';
      }
      this.querySelector('.njs-toolbar-count').textContent=this.querySelector('.njs-count').textContent;
      if(this.dataset.listReady==='true')document.dispatchEvent(new CustomEvent('njt:list-ready'));
      this.renderChips(state);this.renderStatus();
      if(rebuildFilters && !this.dialog.open && !this.form.contains(document.activeElement)) this.renderFilters();
      if(anchor){const node=[...this.querySelector('.njs-grid').children].find(item=>item.dataset.productId===anchor.id);if(node){const delta=node.getBoundingClientRect().top-anchor.top;if(Math.abs(delta)>.5)window.scrollBy({top:delta,left:0,behavior:'instant'});}}
    }
    renderChips(state) {
      const chips=[];
      const add=(key,value,label)=>{const url=new URL(this.url);url.searchParams.delete(key,value);url.searchParams.delete('page');chips.push(`<a href="${escape(url)}" aria-label="${escape(this.t('remove')+' '+label)}">${escape(label)} ×</a>`);};
      state.brands.forEach(v=>add(keys.brand,v,v)); state.heights.forEach(v=>add(keys.height,v,this.heightLabel(v)));
      state.positions.forEach(v=>add(keys.position,v,this.t(v)));if(state.stock)add(keys.stock,'1',this.t('in_stock'));
      if(state.min)add(keys.min,state.min,this.t('from')+' '+this.money.format(Number(state.min)));
      if(state.max)add(keys.max,state.max,this.t('to')+' '+this.money.format(Number(state.max)));
      this.querySelector('.njs-chips').innerHTML=chips.join('');
    }
    renderFilters() {
      const state=this.state();const products=[...this.products.values()];
      const open=new Set([...this.form.querySelectorAll('details[open]')].map(e=>e.dataset.group));
      const group=(key,label,content,defaultOpen=false)=>`<details class="njs-group" data-group="${key}" ${open.has(key)||defaultOpen?'open':''}><summary>${escape(label)}</summary><div class="njs-options">${content}</div></details>`;
      const options=(key,values,selected,labels={})=>values.map(([value,count])=>`<label><input type="checkbox" name="${keys[key]}" value="${escape(value)}" ${selected.includes(value)?'checked':''}><span>${escape(labels[value]||value)}</span><small>${count}</small></label>`).join('');
      const counts=(key,get)=>{const map=new Map();products.filter(p=>this.model.matches(p,state,key)).forEach(p=>new Set(get(p)).forEach(v=>{if(key==='height'&&!this.model.matches(p,{...state,heights:[v]}))return;map.set(v,(map.get(v)||0)+1);}));return [...map];};
      const brands=counts('brand',p=>p.brand?[p.brand]:[]).sort((a,b)=>a[0].localeCompare(b[0]));state.brands.forEach(v=>{if(!brands.some(([x])=>x===v))brands.push([v,0]);});
      const categories=[['suspension','all','all'],['suspension-lift-kit','lifts','lifts'],['spacer-leveling-lift-kit','leveling','leveling'],['shocks-1','shocks','shocks'],['coils-struts','coils','coils'],['body-lifts','body','body_lifts'],['control-arms-track-bars','arms','arms'],['steering-stablizer-tie-rod-drag-link','steering','steering'],['ball-joints','ball','ball_joints'],['sway-bar-kits-bump-stops','sway','sway_bars'],['leaf-springs-air-bags','leaf','leaf_springs'],['lift-kit-components-accessories','components','lift_components']];
      const categoryGroup=group('category',this.t('more_parts'),categories.map(([handle,key,label])=>`<label><input type="radio" name="njs_category" value="${handle}" ${state.category===key?'checked':''}><span>${escape(this.t(label))}</span></label>`).join(''),true);
      let html='';
      if(['all','lifts','leveling','body','shocks','coils'].includes(state.category)) {
        const order=new Map(this.model.heightGroups.map((group,index)=>[group.value,index]));
        const heights=counts('height',p=>this.model.heightOptions(p,state.vehicle)).sort((a,b)=>(order.get(a[0])??999)-(order.get(b[0])??999));
        state.heights.forEach(v=>{if(!heights.some(([x])=>x===v))heights.push([v,0]);});
        html+=group('height',this.t(state.category==='shocks'?'fits_height':'lift_height'),options('height',heights,state.heights,Object.fromEntries(heights.map(([value])=>[value,this.heightLabel(value)]))),true);
      }
      html+=group('brand',this.t('brand'),options('brand',brands,state.brands),true);
      html+=categoryGroup;
      if(state.category==='shocks') html+=group('position',this.t('position'),options('position',counts('position',p=>p.positions),state.positions,{front:this.t('front'),rear:this.t('rear')}),true);
      html+=group('availability',this.t('availability'),`<label><input type="checkbox" name="${keys.stock}" value="1" ${state.stock?'checked':''}><span>${escape(this.t('in_stock'))}</span></label>`);
      html+=group('price',this.t('price'),`<label>${escape(this.t('from'))}<input type="number" name="${keys.min}" min="0" step="0.01" value="${escape(state.min)}"></label><label>${escape(this.t('to'))}<input type="number" name="${keys.max}" min="0" step="0.01" value="${escape(state.max)}"></label>`);
      const sorts=['best-selling','price-ascending','price-descending','title-ascending','title-descending','created-descending'];
      html+=`<label class="njs-sort">${escape(this.t('sort'))}<select name="sort_by">${sorts.map(s=>`<option value="${s}" ${state.sort===s?'selected':''}>${escape(this.t(s))}</option>`).join('')}</select></label>`;
      this.form.querySelector('.njs-filter-fields').innerHTML=html;
    }
    card(p,state,index=0) {
      const url=new URL(p.url,location.origin); if(state.vehicle)url.searchParams.set(vehicleKey,state.vehicle);
      for(const key of previewKeys)if(this.url.searchParams.has(key))url.searchParams.set(key,this.url.searchParams.get(key));
      const applicationHeights=this.model.forVehicle(p,state.vehicle);
      const choices = state.heights.length ? applicationHeights.filter(h => state.heights.some(value=>this.model.heightMatches(h,value))) : applicationHeights;
      const variantChoices = choices.filter(h => h.variantId).map(h => h.variant);
      const candidates=variantChoices.length?variantChoices:(p.variants||[]);
      const eligible=candidates.filter(v=>(!state.stock||(p.liveInventory?v.stock>0:v.available))&&(state.min===''||v.price>=Number(state.min)*100)&&(state.max===''||v.price<=Number(state.max)*100)).sort((a,b)=>a.price-b.price);
      const variant=eligible[0]||candidates[0];
      if (variant) url.searchParams.set('variant',variant.id);
      const hasStock=variant ? variant.stock>0 : p.hasStock;
      const available=variant ? variant.available : p.available;
      const stockLabel=!available?'out_of_stock':hasStock?'in_stock':'available_to_order';
      const quantity=stockLabel==='in_stock' && Number.isFinite(variant?.stock) && variant.stock>0 ? `<span class="njs-stock-quantity">${escape(this.t('quantity_available').replace('__COUNT__',variant.stock>=50?'50+':variant.stock))}</span>` : '';
      const stock=stockLabel==='in_stock' ? `<div class="njs-stock"><strong>${escape(this.t('in_stock'))}</strong>${quantity}</div>` : `<div class="njs-stock njs-stock-order"><strong>${escape(this.t('no_stock'))}</strong><span class="njs-order-note">${escape(this.t(stockLabel==='available_to_order'?'order_note':'out_of_stock'))}</span></div>`;
      const price=variant?.price??p.price,compare=variant?.compare??p.compare;
      const sale=compare>price;
      const truck='<svg aria-hidden="true" viewBox="0 0 28 24" fill="currentColor"><path d="M2 3h15a1 1 0 0 1 1 1v3h4l5 6v6h-3a4 4 0 0 0-8 0H11a4 4 0 0 0-8 0H1V4a1 1 0 0 1 1-1zm17 6v5h6l-4-5z"/><circle cx="7" cy="19" r="3"/><circle cx="20" cy="19" r="3"/></svg>';
      const shipping=hasStock && available && this.dataset.currency==='CAD' && price>Number(this.dataset.freeShippingThreshold||35000) ? `<span class="njs-shipping">${truck}<span>${escape(this.t('free_shipping'))}</span></span>` : '';
      return `<li data-product-id="${escape(p.id)}"><article class="njs-card"><a class="njs-card-image" href="${escape(url)}">${p.image?`<img src="${escape(p.image)}" alt="${escape(p.title)}" width="600" height="600" loading="${index<2?'eager':'lazy'}" decoding="async">`:`<span>${escape(this.t('view_product'))}</span>`}</a><div class="njs-card-body"><h3><a href="${escape(url)}">${escape(p.title)}</a></h3><p class="njs-price${sale?' njs-price-sale':''}"><span class="njs-current-price">${new Set(eligible.map(v=>v.price)).size>1?escape(this.t('from'))+' ':''}${escape(this.money.format(price/100))}</span>${sale?` <s>${escape(this.money.format(compare/100))}</s> <span class="njs-sale-inline">${escape(this.t('sale'))}</span>`:''}</p>${stock}${shipping}<a class="njs-view" href="${escape(url)}">${escape(this.t('view_product'))}</a></div></article></li>`;
    }
  }
  customElements.define('njt-suspension',SuspensionBrowser);
})();
